import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const links = [
    { href: "#services", label: "Services" },
    { href: "#tires", label: "Tires" },
    { href: "#wholesale", label: "Wholesale" },
];

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 8);
        onScroll();
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, [setScrolled]);

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
                scrolled
                    ? "bg-black/70 backdrop-blur-xl border-b border-white/10"
                    : "bg-transparent border-b border-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-36 flex items-center justify-between">
                <Logo size={164} />
                <nav className="hidden md:flex items-center gap-8">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-${l.label.toLowerCase()}`}
                            className="font-display uppercase tracking-[0.18em] text-sm transition-colors text-zinc-300 hover:text-white"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>
                <div className="hidden md:block">
                    <a
                        href="#contact"
                        data-testid="nav-book-service-cta"
                        className="bg-orange-600 hover:bg-orange-500 text-white font-display uppercase tracking-[0.18em] text-sm px-5 py-2.5 rounded-sm transition-colors glow-orange"
                    >
                        Book a Service
                    </a>
                </div>
                <button
                    data-testid="mobile-menu-toggle"
                    onClick={() => setOpen((v) => !v)}
                    className="md:hidden text-white p-2"
                    aria-label="Toggle menu"
                >
                    {open ? <X size={20} /> : <Menu size={20} />}
                </button>
            </div>
            {open && (
                <div className="md:hidden bg-black/95 backdrop-blur border-t border-white/10">
                    <div className="flex flex-col px-6 py-4 gap-4">
                        {links.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                onClick={() => setOpen(false)}
                                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                                className="font-display uppercase tracking-[0.18em] text-sm text-zinc-200"
                            >
                                {l.label}
                            </a>
                        ))}
                        <a
                            href="#contact"
                            onClick={() => setOpen(false)}
                            data-testid="mobile-nav-book-service-cta"
                            className="bg-orange-600 text-white font-display uppercase tracking-[0.18em] text-sm px-4 py-3 rounded-sm text-center"
                        >
                            Book a Service
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
}
